import classNames from 'classnames';
import PageDotsLoader from 'components/animations/Loaders/PageDotsLoader';
import Stack from 'components/containers/Stack/Stack';
import HelperText from 'components/generics/fields/TextField/HelperText';
import classes from 'components/generics/fields/TextField/index.module.scss';
import Typography from 'components/generics/texts/Typography';
import {
  ChangeEvent,
  DetailedHTMLProps,
  InputHTMLAttributes,
  useState,
} from 'react';

const NON_NUMERIC_ERROR_MSG =
  'Number input must be numeric. \nProvide property: isNumeric={true}';

export interface TextFieldProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  isError?: boolean;
  isFullWidth?: boolean;
  isNumeric?: boolean;
  helperText?: string | null;
  prefix?: string;
  label?: string;
  isLoading?: boolean;
  inputStyle?: any;
}

const TextField = ({
  className,
  helperText,
  isError,
  isFullWidth,
  prefix,
  ref,
  onChange,
  isNumeric,
  label,
  onFocus,
  onBlur,
  value,
  type,
  isLoading,
  inputStyle,
  ...props
}: TextFieldProps) => {
  // if (type === 'number' && !isNumeric) throw new Error(NON_NUMERIC_ERROR_MSG);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    if (isNumeric && Number.isNaN(Number(event.target.value))) return;
    onChange(event);
  };

  const [isFocused, setIsFocused] = useState(false);

  return (
    <label
      className={classNames(
        classes.field,
        {
          [classes.fullwidth]: isFullWidth,
        },
        className
      )}
    >
      {!!label && (
        <div
          className={classNames(classes.label, {
            [classes.focused]: isFocused || value,
          })}
        >
          {label}
        </div>
      )}
      <Stack
        direction="row"
        align="center"
        className={classes.inputContainer}
      >
        {!!prefix && (
          <Typography className={classes.prefix}>{prefix}</Typography>
        )}
        <input
          {...props}
          type={type}
          value={value}
          onChange={handleChange}
          ref={ref}
          onFocus={(...args) => {
            setIsFocused(true);
            onFocus && onFocus(...args);
          }}
          onBlur={(...args) => {
            setIsFocused(false);
            onBlur && onBlur(...args);
          }}
          className={classNames(
            classes.input,
            {
              [classes.hiddenPlaceholder]: label,
            },
            inputStyle && classes.inputStyle
          )}
        />
      </Stack>
      {!!helperText && (
        <HelperText
          text={helperText}
          isError={isError}
        />
      )}
      <PageDotsLoader isLoading={isLoading} />
    </label>
  );
};

export default TextField;
